/** @jsxImportSource react */
import { cn } from '@common/lib/clsxm';

export interface BoxedSectionProps {
  id?: string;
  heading?: string;
  children: React.ReactNode;
  className?: string;
}

export default function BoxedSection({
  id,
  heading,
  children,
  className,
}: BoxedSectionProps) {
  return (
    <section
      className={cn(
        'space-y-6 rounded-xl bg-white py-8 px-4 shadow-subtle md:px-8',
        className
      )}
      id={id}
    >
      {!!heading && <h2 className='font-t-m capitalize-first'>{heading}</h2>}
      {children}
    </section>
  );
}
